import {Radio, RadioProps} from "@mui/material";
import {BarekamIcon, IconVariants} from "../icon/barekam-icon";

const BarekamRadio = (props: BarekamRadioProps) => {
    return (
        <div>
            <span>{props.label}</span>
            <Radio icon={<BarekamIcon variant={IconVariants.radio} isChecked={false}/>}
                   checkedIcon={<BarekamIcon variant={IconVariants.radio} isChecked={true}/>}
                   {...props}/>
        </div>
    );
}

export default BarekamRadio;

interface BarekamRadioProps extends RadioProps {
    label?: string

}
